import React from 'react';
import { Box, Typography, IconButton, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';

function XIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 1200 1227"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 0h273.6l329.7 451.6L950.4 0H1200L750.6 623.6 1200 1227H926.4L600 797.2 249.6 84.2H175.2zm175.2 84.2l424.8 570.2 424.8-570.2H950.4L600 523.8 249.6 84.2H175.2zm849.6 1058.6L600 703.2 175.2 1142.8h74.4l350.4-439.6 350.4 439.6h74.4z"
        fill="currentColor"
      />
    </svg>
  );
}

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'primary.main',
        color: 'white',
        py: 1.5,
        px: 2,
        mt: 2,
        boxShadow: '0 -2px 8px rgba(0,0,0,0.08)',
        borderTop: '2px solid #1565c0',
        fontFamily: '"Orbitron", "Roboto", "Helvetica", "Arial", sans-serif',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'stretch', md: 'center' },
          justifyContent: 'space-between',
          maxWidth: 1200,
          mx: 'auto',
          width: '100%',
          gap: { xs: 3, md: 0 },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: { xs: 'center', md: 'flex-start' }, mb: { xs: 0, md: 0 }, flex: { xs: 1, md: 'none' } }}>
          <img
            src="/images/race-with-me-logo.png"
            alt="RaceWithMe - F1 Game Racing Community Logo"
            style={{ height: '36px', cursor: 'pointer', verticalAlign: 'middle' }}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: { xs: 1, md: 'none' }, gap: 2 }}>
        <IconButton
            component="a"
            href="https://www.instagram.com/racewithmeofficial/"
            target="_blank"
            rel="noopener"
            sx={{ color: 'white', mx: 0.5 }}
            aria-label="Instagram"
          >
            <InstagramIcon fontSize="medium" />
          </IconButton>
          <IconButton
            component="a"
            href="https://x.com/racewithmef1"
            target="_blank"
            rel="noopener"
            sx={{ color: 'white', mx: 0.5 }}
            aria-label="X"
          >
            <XIcon style={{ width: 24, height: 24 }} />
          </IconButton>
          <IconButton
            component="a"
            href="https://www.youtube.com/@sfr_doran"
            target="_blank"
            rel="noopener"
            sx={{ color: 'white', mx: 0.5 }}
            aria-label="YouTube"
          >
            <YouTubeIcon fontSize="medium" />
          </IconButton>
        </Box>
        <Box sx={{ display: { xs: 'none', md: 'flex' }, flex: { xs: 'none', md: 'none' } }}>
          <img
            src="/images/race-with-me-logo.png"
            alt="RaceWithMe - F1 Game Racing Community Logo"
            style={{ height: '36px', cursor: 'pointer', verticalAlign: 'middle' }}
          />
        </Box>
      </Box>
      <Typography variant="body2" align="center" sx={{ mt: 2, opacity: 0.8 }}>
        © {new Date().getFullYear()} Race With Me. All rights reserved.
        {' · '}
        <Link component={RouterLink} to="/privacy" sx={{ color: 'inherit', textDecoration: 'underline' }}>Privacy Policy</Link>
      </Typography>
    </Box>
  );
}

export default Footer; 